import React from 'react';

import { useState, useRef, useEffect } from 'react';

import { Formik } from 'formik';
import * as yup from 'yup';

import { Button, Form, Stack, Col, Row } from 'react-bootstrap';

import useRequest from '../helper/useRequest';
import { toast } from 'react-toastify';

import TwoFAModal from '../helper/Modal/TwoFAModal';

import { password, passwordRepeat } from '../helper/Schema';

import MandatoryFieldNotice from '../helper/MandatoryFieldNotice';

const schema = yup.object().shape({
    oldPassword: yup.string().required("Bitte das alte Passwort eingeben."),
    Password: password,
    PasswordRepeat: passwordRepeat
});



const UserPassword = () => {
    const { request } = useRequest();

    const [modal, setModal] = useState(false);
    const [status, setStatus] = useState(false);
    const [auth, setAuth] = useState("");
    const [url, setUrl] = useState("");

    const formRef = useRef(null);

    const loadData = async () => {
        try {
            let result = await request("/User/Get2FA");
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.info(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
                }
            }
            else {
                setAuth(json.auth);
                setUrl(json.url);
                setStatus(json.status);
            }
        }
        catch (ex) {
            toast.error(ex.message);
        }
    };

    const updatePassword = async (values) => {
        let result = await request("/User/UpdatePassword", values);
        let json = result.data;
        if (json.r != 1) {
            if (json.message) {
                toast.error(json.message);
            }
            else {
                toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
            }
        }
        else {
            formRef.current.setFieldValue('oldPassword', '');
            formRef.current.setFieldValue('Password', '');
            formRef.current.setFieldValue('PasswordRepeat', '');
            toast.success("Ihr Passwort wurde erfolgreich geändert.");
        }
    };

    const open2FA = async () => {
        setModal(true);
    };

    const openDisable2FA = async () => {
        setModal(true);
    };

    useEffect(() => {
        loadData();
    }, []);

    return (
        <>
            <Formik
                innerRef={(f) => formRef.current = f}
                validationSchema={schema}
                onSubmit={(values) => {
                    updatePassword(values);
                }}
                initialValues={{
                    oldPassword: '',
                    Password: '',
                    PasswordRepeat: ''
                }}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                }) => {
              
                    return (
                        <Form className="mt-3" noValidate onSubmit={handleSubmit}>
                            <Row>
                                <Col md="6">
                                    <Form.Group className="mb-3" controlId="oldPassword">
                                        <Form.Label className="required">Altes Passwort</Form.Label>
                                        <Form.Control isInvalid={errors.oldPassword && touched.oldPassword} type="password" placeholder="" name="oldPassword" value={values.oldPassword} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.oldPassword}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="Password">
                                        <Form.Label className="required">Neues Passwort</Form.Label>
                                        <Form.Control isInvalid={errors.Password && touched.Password} type="password" placeholder="" name="Password" value={values.Password} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Password}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="PasswordRepeat">
                                        <Form.Label className="required">Neues Passwort wiederholen</Form.Label>
                                        <Form.Control isInvalid={errors.PasswordRepeat && touched.PasswordRepeat} type="password" placeholder="" name="PasswordRepeat" value={values.PasswordRepeat} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.PasswordRepeat}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <div>
                                <Button variant="secondary" type="submit" className="mr-2">
                                    <i className="fa-solid fa-check mr-2"></i>Passwort speichern
                                </Button>
                                {!status && (
                                    <Button variant="primary" type="button" onClick={() => open2FA()}>
                                        <i className="fas fa-key mr-2"></i>Zwei-Faktor Authentifizierung aktivieren
                                    </Button>
                                )}

                                {status && (
                                    <Button variant="primary" type="button" onClick={() => openDisable2FA()}>
                                        <i className="fas fa-key mr-2"></i>Zwei-Faktor Authentifizierung deaktivieren
                                    </Button>
                                )}
                                        
                            </div>

                            <MandatoryFieldNotice />
                        </Form>
                    )
                }}
            </Formik>
            <TwoFAModal modal={modal} setModal={setModal} status={status} setStatus={setStatus} auth={auth} url={url} />
        </>
    )
}

export default UserPassword;